import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------invocie settings page api's-------------------------------->
    /**
     * 
     *invoice settigns udpated
     */
    postInvoiceSettings(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/settings/invoice', data)
    },
    customFieldCreate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/settings/customfieldcreate', data)
    },
    customFieldUpdate(id, data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/settings/customfieldupdate/' + id, data)
    },
    getCustomList(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/settings/customfieldindex', data)
    },
    getCustomLimit(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/settings/LimitCount', data)
    },
    configureAccessUpdate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/settings/configureAccessUpdate', data)
    },
    getCustomConfigure(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/settings/configureAccessView', data)
    },

    /**
     * 
     *filter settigns udpated
     */
    getFilterDetailsSettings(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/settings/filterdetails', data)
    },
    /**
     * 
     *general settings udpated
     */
    postGeneralSettings(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/settings/general', data)
    },
    getMailDetailsSettings(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/mail/index', data)
    },
    MailtemplateCreate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/mail/create', data)
    },
    MailtemplateUpdate(id, field, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/mail/update/' + id, field)
    },
    MailtemplateView(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/mail/view/' + id)
    },
    MailtemplateDelete(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/mail/delete', id)
    },
    /**
     * 
     *invoice settigns list
     */
    getInvoiceSettings(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/settings/invoiceList', data)
    },
    postdelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/settings/customfielddelete', data)
    },
    /**
     * get particular template print details
     */
    getPrintSettings(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/print/view', data)
    },
    postPrintSettings(id, data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/print/update/' + id, data)
    },
    activeInvoiceTemp(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/print/activetemplate', data)
    },
    getFilter(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/settings/filterview', data)
    },
    //opening balance
    getOpeningBalance(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/openingbalance')
    },
    getOpeningBalanceType(type, page, show, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/openingbalance/viewpage/' + type + '/' + page + '/' + show)
    },
    getOpeningBalanceValidationstatus(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/openingbalance/importvalidation', data)
    },
    getOpeningBalanceimport(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/openingbalance/import', data)
    },
}